import api from "./api";

export default class SupervisorClientesApi {

    static getClientesSupervisor = async (id: number) => {
        const response = await api.get(`/SupervisorClientes/${id}`);
        return response.data;
    };

    static postClientesSupervisor = async (id: number) => {
        const response = await api.post(`/SupervisorClientes/${id}`);
        return response.data;
    };
  
    
};

